<div class="flex justify-end">
    <button mat-icon-button class="mt-2 mr-2 p-2 bg-gray-400" (click)="openInfo()"
        matTooltip="Click for information about this page.">
        <i class="fa-solid fa-info text-2xl text-gray-600"></i>
    </button>
</div>
<div class="flex flex-col items-center">
    <div id="map2" class="rounded"></div>
    <div *ngIf="loading" class="my-4 flex flex-col justify-center items-center">
        Loading...
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="slidersVisible && !loading" class="flex flex-col justify-center items-center my-4">
        <mat-card>
            <mat-card-header class="justify-center text-md" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                Proportion of arable land under organic farming (%)
            </mat-card-header>
            <mat-card-content>
                <div class="flex flex-row gap-4 m-4">
                    <div class="flex flex-col items-center justify-center">
                        <mat-slider [max]="100" [min]="0" [step]="1" [discrete]="true">
                            <input matSliderThumb [(ngModel)]="currentOrganicPerc" #slider>
                        </mat-slider>
                        <div class="text-center text-xs text-gray-600"
                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                            Current
                        </div>
                    </div>
                    <div class="flex flex-col items-center justify-center">
                        <mat-slider [max]="100" [min]="0" [step]="1" [discrete]="true">
                            <input matSliderThumb [(ngModel)]="targetOrganicPerc" #slider>
                        </mat-slider>
                        <div class="text-center text-xs text-gray-600"
                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                            Target
                        </div>
                    </div>
                    <button mat-raised-button id="saveButton" class="m-1"
                        [disabled]="targetOrganicPerc === null || currentOrganicPerc === null"
                        (click)="loadRadarData()">
                        <i class="fa-solid fa-chart-line mr-1"></i>
                        Calculate Benefits
                    </button>
                </div>
            </mat-card-content>

        </mat-card>
    </div>

    <div *ngIf="radarAvailable" class="w-full flex justify-center items-center my-4 px-4">
        <mat-card class="w-full max-w-7xl">
            <div class="text-center text-xl font-medium text-gray-600 my-4"
                style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                Change in benefits when switching from conventional to organic
            </div>
            <mat-card-content>
                <div *ngIf="!lineChartAvailable" class="mt-6 flex flex-col justify-center items-center">
                    <div class="w-full max-w-lg h-80 flex justify-center items-center">
                        <canvas baseChart [type]="'radar'" [datasets]="radarData" [labels]="radarChartLabels"
                            [options]="radarChartOptions" [legend]="true" class="max-w-full max-h-full">
                        </canvas>
                    </div>
                    <div class="w-full max-w-xs mt-4">
                        <label for="parameter-select" class="text-gray-800 font-light">Select Benefit</label>
                        <mat-select id="parameter-select" [(ngModel)]="selectedNcp"
                            (selectionChange)="onNcpChange($event.value)" class="border border-gray-300 rounded p-3 w-full">
                            <mat-option *ngFor="let ncp of ncpLabels" [value]="ncp">
                                {{ ncp }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div *ngIf="lineChartAvailable" class="mt-6 w-full">
                    <div class="flex flex-col xl:flex-row gap-8 w-full">
                        <!-- Left side - Radar Chart -->
                        <div class="flex-1 min-w-0">
                            <div class="w-full h-80 flex justify-center items-center">
                                <canvas baseChart [type]="'radar'" [datasets]="radarData" [labels]="radarChartLabels"
                                    [options]="radarChartOptions" [legend]="true" class="max-w-full max-h-full">
                                </canvas>
                            </div>
                        </div>
                        
                        <!-- Right side - Controls and Secondary Charts -->
                        <div class="flex-1 min-w-0">
                            <!-- Controls -->
                            <div class="w-full flex flex-col sm:flex-row gap-4 mb-6">
                        <div class="flex-1 min-w-48">
                            <label for="parameter-select" class="text-gray-800 font-light block mb-2">Select Benefit</label>
                            <mat-select id="parameter-select" [(ngModel)]="selectedNcp"
                                        (selectionChange)="onNcpChange($event.value)"
                                        class="border border-gray-300 rounded p-3 w-full">
                                        <mat-option *ngFor="let ncp of ncpLabels" [value]="ncp">
                                            {{ ncp }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div class="flex flex-col justify-end">
                                    <mat-radio-group [(ngModel)]="selectedChart" (change)="onChartSelectionChange()" 
                                        class="flex flex-col gap-2">
                          <mat-radio-button value="line">Line Chart</mat-radio-button>
                          <mat-radio-button value="density">Density Plot</mat-radio-button>
                          <mat-radio-button value="table">Table</mat-radio-button>
                        </mat-radio-group>
                    </div>
                            </div>
                            
                            <!-- Chart/Table Container -->
                            <div class="w-full">
                                <!-- Line Chart -->
                                <div *ngIf="selectedChart === 'line'" class="w-full h-64">
                                    <canvas baseChart [type]="'line'"
                                        [datasets]="lineChartData.datasets" [labels]="lineChartData.labels"
                                        [options]="lineChartOptions" class="max-w-full max-h-full">
                                    </canvas>
                                </div>
                                
                                <!-- Density Chart -->
                                <div *ngIf="selectedChart === 'density'" class="w-full h-64">
                                    <canvas baseChart [type]="'line'"
                                        [datasets]="densityChartData.datasets" [labels]="densityChartData.labels"
                                        [options]="densityChartOptions" class="max-w-full max-h-full">
                                    </canvas>
                                </div>
                                
                                <!-- Table -->
                                <div *ngIf="selectedChart === 'table'" class="w-full overflow-x-auto">
                                    <table class="w-full border border-gray-300 text-left min-w-full">
                                        <thead class="bg-gray-100">
                                            <tr>
                                                <th class="px-4 py-2 border text-sm whitespace-nowrap">Benefit</th>
                                                <th class="px-4 py-2 border text-sm whitespace-nowrap">Unit</th>
                                                <th class="px-4 py-2 border text-sm whitespace-nowrap">X% Conventional</th>
                                                <th class="px-4 py-2 border text-sm whitespace-nowrap">Y% Organic</th>
                                                <th class="px-4 py-2 border text-sm whitespace-nowrap">Effect of Shift</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let row of tableData.data" class="odd:bg-gray-50">
                                                <td class="px-4 py-2 border text-sm">{{ row.ncp }}</td>
                                                <td class="px-4 py-2 border text-sm">{{ row.unit }}</td>
                                                <td class="px-4 py-2 border text-sm">{{ row.current }}</td>
                                                <td class="px-4 py-2 border text-sm">{{ row.target }}</td>
                                                <td class="px-4 py-2 border text-sm">{{ row.effect }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div *ngIf="noData" class="w-full flex justify-center items-center mt-4">
        <mat-card class="w-full sm:w-3/4 lg:w-2/3">
            <div class="text-center text-lg font-semibold text-gray-700"
                style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                No data available.
            </div>
        </mat-card>
    </div>
</div>